export default __webpack_public_path__ + "static/media/avatar.a64db376.svg";